/* @flow */
// typecheck: ignore file
import React from 'react';
import Text from 'components/Text.jsx';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import Button from 'components/Button.jsx';
import ZopimLink from 'support/components/ZopimLink.jsx';
import ZopimChevronBox from 'support/components/ZopimChevronBox.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import UserNavigationMenu from 'components/UserNavigationMenu.jsx';
import AdminLayoutHeaderOrganizationName from 'admin/components/AdminLayoutHeaderOrganizationName.jsx';

import './styles/AdminLayoutHeader.scss';

type Context = {
  router: {
    params: {
      schoolId?: number,
      districtId?: number,
    }
  }
}

function AdminLayoutHeader(_props: *, context: Context) {
  const { router } = context;
  const { schoolId, districtId } = router.params;

  return (
    <div className="AdminLayoutHeader">
      <div className="AdminLayoutHeader-tile">
        <span>Admin Console</span>
        <AdminLayoutHeaderOrganizationName organizationId={schoolId || districtId}>
          {(name) =>
            <Text weight="light" className="AdminLayoutHeader-organizationName">
              {name}
            </Text>
          }
        </AdminLayoutHeaderOrganizationName>
      </div>

      <div className="AdminLayoutHeader-nav">
        <div className="AdminLayoutHeader-nav-help">
          <ZopimLink>
            <ZopimChevronBox />
          </ZopimLink>
          <ModalTrigger modal={<SupportDialog />}>
            <Link color="white">
              <Glyph name="help" size="xlarge" solo />
            </Link>
          </ModalTrigger>
        </div>
        <UserNavigationMenu showSettings showLogout>
          <Link color="white">
            <Glyph name="avatar-circle" size="xlarge" solo />
          </Link>
        </UserNavigationMenu>
        <div className="AdminLayoutHeader-nav-remind">
          <Button size="xxsmall" level="secondary" color="white" target="_blank" to="/classes">
            <Glyph name="remind-icon" size="large" />
            <span>Launch Remind</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

AdminLayoutHeader.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default AdminLayoutHeader;



// WEBPACK FOOTER //
// ./src/admin/components/AdminLayoutHeader.jsx